var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lottery-reward-image-comp",style:(_setup.rootStyle)},[_c('img',{staticClass:"image",attrs:{"src":_vm.image,"alt":_vm.alt}}),(_vm.icon)?_c('img',{staticClass:"icon",attrs:{"src":_vm.icon,"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }